import { Box, SxProps, Theme, alpha } from "@mui/material";
import type { JSX } from "react";
import React from "react";

export const CircularIconWrapper = ({
  children,
  sx,
  backgroundColor,
  size = "48px",
}: {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  backgroundColor: string;
  size?: number | string;
}): JSX.Element => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: alpha(backgroundColor, 0.16),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
